const initNewsletterPopup = () => {
  const COOKIE_NAME = 'newsletter_popup_closed';
  const POPUP_DELAY = 5000;
  const COOKIE_EXPIRY_DAYS = 30;

  const popup = document.getElementById('newsletterPopup');
  if (!popup) return;

  function setCookie() {
    const expiryDate = new Date();
    expiryDate.setDate(expiryDate.getDate() + COOKIE_EXPIRY_DAYS);
    document.cookie = `${COOKIE_NAME}=true; expires=${expiryDate.toUTCString()}; path=/`;
  }

  function closePopup() {
    popup.style.display = 'none';
    setCookie();
  }

  // Show popup if it hasn't been closed before
  if (!document.cookie.includes(`${COOKIE_NAME}=true`)) {
    setTimeout(() => {
      popup.style.display = 'flex';
      popup.classList.add('fade-in');
    }, POPUP_DELAY);
  }

  const closeButton = document.querySelector('.close-newsletter');
  if (closeButton) {
    closeButton.addEventListener('click', (e) => {
      e.preventDefault();
      closePopup();
    });
  }

  popup.addEventListener('click', (e) => {
    if (e.target === popup) {
      closePopup();
    }
  });

  const newsletterForm = popup.querySelector('.newsletter-popup');

  if (newsletterForm) {
    newsletterForm.addEventListener('porta:valid', () => {
      setCookie();
      closePopup();
    });
  }
};

export default initNewsletterPopup;
